import { NgClass } from "@angular/common";
import {
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
  signal,
} from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentViewType } from "../../content-view-type.enum";

@Component({
  standalone: true,
  selector: "app-content-view-type-selector",
  templateUrl: "./content-view-type-selector.component.html",
  styleUrl: "./content-view-type-selector.component.scss",
  imports: [MatIcon, NgClass, MatIconButton],
})
export class ContentViewTypeSelectorComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  protected readonly noCalendar = input<boolean>(false);
  @Output() readonly viewTypeChange = new EventEmitter<ContentViewType>();
  protected readonly ContentViewType = ContentViewType;
  protected readonly activeViewType = signal<ContentViewType>(
    ContentViewType.Grid,
  );

  protected onActionChangeViewType(viewType: ContentViewType): void {
    this.activeViewType.set(viewType);
    this.viewTypeChange.emit(viewType);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        view: viewType,
      },
      queryParamsHandling: "merge",
    });
  }

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const viewType = Object.values(ContentViewType).includes(params.view)
        ? params.view
        : ContentViewType.Grid;

      if (params.view !== viewType) {
        this.onActionChangeViewType(viewType);
      }
    });
  }
}
